import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: "RubleIcon",
  functional: true,
  render: function render(h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([
        {
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 169.201 169.201",
            fill: "currentColor",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          },
          class: "feather"
        },
        ctx.data
      ]),
      [
        h("path", {
          attrs: {
            d:
              "M132.937,165.711c-9.055,0-16.469-7.159-16.88-16.114h-4.92c-0.411,8.955-7.825,16.114-16.88,16.114\n" +
              "\ts-16.469-7.159-16.88-16.114h-4.92c-0.411,8.955-7.825,16.114-16.88,16.114s-16.469-7.159-16.88-16.114h-4.92\n" +
              "\tc-0.411,8.955-7.825,16.114-16.88,16.114C7.58,165.711,0,158.131,0,148.814V20.387C0,11.07,7.58,3.49,16.897,3.49\n" +
              "\ts16.897,7.58,16.897,16.897v2.737h4.885v-2.737c0-9.317,7.58-16.897,16.897-16.897s16.897,7.58,16.897,16.897v2.737h4.885v-2.737\n" +
              "\tc0-9.317,7.58-16.897,16.897-16.897s16.897,7.58,16.897,16.897v2.737h4.885v-2.737c0-9.317,7.58-16.897,16.897-16.897\n" +
              "\ts16.897,7.58,16.897,16.897v2.776h7.385c0.084,0,0.168,0.004,0.25,0.013c6.492,0.133,11.732,5.456,11.732,11.979\n" +
              "\tc0,6.521-5.234,11.842-11.722,11.98c-0.086,0.009-0.173,0.014-0.261,0.014h-7.385v78.461h7.385c0.089,0,0.176,0.005,0.262,0.014\n" +
              "\tc6.487,0.14,11.721,5.46,11.721,11.979s-5.234,11.841-11.722,11.979c-0.086,0.009-0.173,0.014-0.261,0.014h-7.402\n" +
              "\tC149.405,158.552,141.991,165.711,132.937,165.711z M121.039,147.097v1.717c0,6.561,5.337,11.897,11.897,11.897\n" +
              "\ts11.897-5.337,11.897-11.897V20.387c0-6.561-5.337-11.897-11.897-11.897s-11.897,5.337-11.897,11.897V147.097z M82.359,147.097\n" +
              "\tv1.717c0,6.561,5.337,11.897,11.897,11.897s11.897-5.337,11.897-11.897V20.387c0-6.561-5.337-11.897-11.897-11.897\n" +
              "\ts-11.897,5.337-11.897,11.897V147.097z M43.68,147.097v1.717c0,6.561,5.337,11.897,11.897,11.897s11.897-5.337,11.897-11.897V20.387\n" +
              "\tc0-6.561-5.337-11.897-11.897-11.897S43.68,13.827,43.68,20.387V147.097z M16.897,8.49C10.337,8.49,5,13.827,5,20.387v128.427\n" +
              "\tc0,6.561,5.337,11.897,11.897,11.897s11.897-5.337,11.897-11.897V20.387C28.795,13.827,23.458,8.49,16.897,8.49z M149.834,144.597\n" +
              "\th7.151c0.077-0.007,0.154-0.011,0.233-0.011c3.851,0,6.982-3.132,6.982-6.982s-3.132-6.982-6.982-6.982\n" +
              "\tc-0.079,0-0.156-0.004-0.233-0.011h-7.151V144.597z M111.154,144.597h4.885v-13.986h-4.885V144.597z M72.475,144.597h4.885v-13.986\n" +
              "\th-4.885V144.597z M33.795,144.597h4.885v-13.986h-4.885V144.597z M111.154,125.611h4.885v-78.5h-4.885V125.611z M72.475,125.611\n" +
              "\th4.885v-78.5h-4.885V125.611z M33.795,125.611h4.885v-78.5h-4.885V125.611z M149.834,42.15h7.151\n" +
              "\tc0.077-0.007,0.154-0.011,0.233-0.011c3.851,0,6.982-3.133,6.982-6.983s-3.132-6.982-6.982-6.982c-0.075,0-0.149-0.003-0.223-0.01\n" +
              "\th-7.162V42.15z M111.154,42.111h4.885V28.125h-4.885V42.111z M72.475,42.111h4.885V28.125h-4.885V42.111z M33.795,42.111h4.885\n" +
              "\tV28.125h-4.885V42.111z"
          }
        })
      ]
    );
  }
};
